function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import Nav from "../default-fixed-nav/nav";
// import type { SlimNavProps } from "./types";
import { NavUsedCar, NavNewCar, NavArticles, NavMovie, NavText,
// NavTextTop,
NavHelpSell, NavAgentCustomer, NavUser, NavHelp, NavApp, NavSearch } from "../../index";
import useBusinessNav from "../hooks/useNav";
import { host, path } from "../nav-util/url";
import ga from "../nav-util/ga";
import { ga4Collect } from "../nav-util/ga4";
import { postInitialCollect, fetchV3Article, fetchSearchSuggest, fetchSearchRecommend } from "../nav-util/api";
import { uuid as UUID } from "@t8891/helper";
import NavServiceText from "../nav-service";
import { useUpdateEffect } from "ahooks";
export var uuid = UUID;
var www = host.www,
  c = host.c,
  auto = host.auto,
  image = host.image;
var onlineService = path.onlineService;
var SlimNav = function SlimNav(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? "slim" : _ref$type,
    onClickBuyCar = _ref.onClickBuyCar,
    onExposured = _ref.onExposured,
    _ref$outSideUserNav = _ref.outSideUserNav,
    outSideUserNav = _ref$outSideUserNav === void 0 ? null : _ref$outSideUserNav;
  var _useBusinessNav = useBusinessNav(),
    usedCarNav = _useBusinessNav.usedCarNav,
    usedCarBrand = _useBusinessNav.usedCarBrand,
    hotData = _useBusinessNav.hotData,
    keyword = _useBusinessNav.keyword,
    userNav = _useBusinessNav.userNav,
    setUserNav = _useBusinessNav.setUserNav,
    handlePostInitialCollect = _useBusinessNav.handlePostInitialCollect,
    def = _useBusinessNav.def,
    newCarBrand = _useBusinessNav.newCarBrand;
  var buyCarTitlle = "買新車";
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    pagePlatform = _useState2[0],
    setPagePlatform = _useState2[1];
  useEffect(function () {
    // 电动车曝光
    ga4Collect("element_exposured", {
      page_sub_business: "中古車首頁",
      page_business: "中古車",
      trigger_id: "2369",
      page_id: "484",
      trigger_name: "電動車",
      next_spm: "38.484.265.554",
      page: "首頁",
      channel: "中古車",
      element_id: "電動車",
      element: "按鈕",
      module: "頂部tab欄",
      tracker_method: "config"
    });
    onExposured === null || onExposured === void 0 ? void 0 : onExposured();
  }, []);
  useEffect(function () {
    var pageRoute = window === null || window === void 0 ? void 0 : window.page_route;
    if (pageRoute === "t8891:index_index") {
      setPagePlatform("t8891-index");
    } else if ((pageRoute === null || pageRoute === void 0 ? void 0 : pageRoute.indexOf("newCar")) !== -1) {
      setPagePlatform("newcar");
    } else {
      setPagePlatform("auto");
    }
  }, []);
  useUpdateEffect(function () {
    if (outSideUserNav) {
      setUserNav(outSideUserNav);
    }
  }, [outSideUserNav]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: 'tc-nav-top-slim',
    className: 'tc-top-nav-slim'
  }, /*#__PURE__*/React.createElement(Nav, {
    type: type,
    nav: {
      usedCar: function usedCar() {
        return /*#__PURE__*/React.createElement(NavUsedCar, {
          onClick: function onClick() {
            return ga(["導航", "中古車"]);
          },
          active: -1,
          dataSource: {
            usedCar: usedCarNav,
            usedCarBrand: usedCarBrand
          },
          www: www,
          auto: auto,
          ga: ga,
          ga4: ga4Collect,
          uuid: uuid
        });
      },
      /* 中古車詳情頁 */
      usedCarAuto: function usedCarAuto() {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavText, {
          id: 'slim-findAutos',
          title: "\u627E\u6C7D\u8ECA",
          navActive: 0,
          onClick: function onClick() {},
          href: "".concat(auto),
          active: -1
        }), /*#__PURE__*/React.createElement(NavText, {
          id: 'slim-findMoto',
          title: "\u627E\u6A5F\u8ECA",
          navActive: 0,
          onClick: function onClick() {},
          href: "".concat(auto, "/usedauto-moto.html"),
          active: -1
        }), /*#__PURE__*/React.createElement(NavText, {
          id: 'slim-findBuz',
          title: "\u4E2D\u53E4\u8ECA\u5546",
          navActive: 0,
          onClick: function onClick() {},
          href: "".concat(auto, "/findBuz-index.html"),
          active: -1
        }), /*#__PURE__*/React.createElement(NavText, {
          id: 'slim-carAppraise',
          title: "\u4F30\u50F9",
          navActive: 0,
          onClick: function onClick() {},
          href: "".concat(auto, "/carResource-carResourceAppraise.html"),
          active: -1
        }), /*#__PURE__*/React.createElement(NavText, {
          id: 'personalSell',
          title: "\u500B\u4EBA\u8CE3\u8ECA",
          navActive: 0,
          innerClassName: "tracking-home-top-nav-personal-sell-".concat(pagePlatform),
          onClick: function onClick() {
            ga4Collect("usedcarResource_clicked", {
              page: "全站首頁",
              channel: "首頁",
              module: "頂部導航",
              element: "按鈕",
              element_id: "個人賣車",
              spm: "",
              next_spm: "2.345.391.782"
            });
          },
          href: "".concat(auto, "/sell-spread.html?source=8891&entry=hp_ohp_topn_pcs"),
          active: -1,
          style: {
            width: "60px"
          }
        }), /*#__PURE__*/React.createElement(NavText, {
          id: 'slim-sellCar',
          title: "\u8CE3\u8ECA\u5FC5\u770B",
          navActive: 0,
          onClick: function onClick() {},
          href: "".concat(auto, "/usedauto-publicity.html"),
          active: -1
        }), /*#__PURE__*/React.createElement(NavServiceText, {
          id: 'slim-service',
          title: "\u670D\u52D9\u4FDD\u969C",
          navActive: 0,
          onClick: function onClick() {},
          href: "".concat(auto),
          active: -1
        }));
      },
      personalSell: function personalSell() {
        return /*#__PURE__*/React.createElement(NavText, {
          id: 'personalSell',
          title: "\u500B\u4EBA\u8CE3\u8ECA",
          navActive: 0,
          innerClassName: "tracking-home-top-nav-personal-sell-".concat(pagePlatform),
          onClick: function onClick() {
            ga4Collect("usedcarResource_clicked", {
              page: "全站首頁",
              channel: "首頁",
              module: "頂部導航",
              element: "按鈕",
              element_id: "個人賣車",
              spm: "",
              next_spm: "2.345.391.782"
            });
          },
          href: "".concat(auto, "/sell-spread.html?source=8891&entry=hp_ohp_topn_pcs"),
          active: -1,
          style: {
            width: "60px"
          }
        });
      },
      valuation: function valuation() {
        return /*#__PURE__*/React.createElement(NavText, {
          id: 'valuation',
          title: "\u4E8C\u624B\u8ECA\u4F30\u50F9",
          navActive: 1,
          href: "".concat(auto, "/carResource/valuation?source=8891&entry=hp_navi_ucv"),
          active: -1
        });
      },
      newCar: function newCar() {
        return /*#__PURE__*/React.createElement(NavNewCar, {
          onClick: function onClick() {
            return ga(["導航", "新車"]);
          },
          active: -1,
          dataSource: newCarBrand,
          www: www,
          auto: "".concat(c),
          ga: ga,
          ga4: ga4Collect,
          uuid: uuid
        });
      },
      // buyCar: () => (
      //   <NavText
      //     id='newTopNav2'
      //     title={buyCarTitlle}
      //     navActive={3}
      //     onClick={() => {
      //       ga(["導航", buyCarTitlle]);
      //       onClickBuyCar?.({ title: buyCarTitlle });
      //     }}
      //     href={`${c}/buyCar`}
      //     active={-1}
      //   />
      // ),
      articles: function articles() {
        return /*#__PURE__*/React.createElement(NavArticles, {
          onClick: function onClick() {
            return ga(["導航", "文章"]);
          },
          href: "".concat(c, "/Articles"),
          active: -1,
          hotData: hotData,
          c: c,
          image: image,
          ga: ga,
          ga4: ga4Collect
        });
      },
      movie: function movie() {
        return /*#__PURE__*/React.createElement(NavMovie, {
          onClick: function onClick() {
            return ga(["導航", "影音"]);
          },
          href: "".concat(c, "/photoMovie-index.html"),
          active: -1,
          c: c,
          image: image,
          ga: ga,
          ga4: ga4Collect,
          fetchV3Article: fetchV3Article
        });
      },
      compare: function compare() {
        return /*#__PURE__*/React.createElement(NavText, {
          id: 'newTopNav5',
          title: "\u6BD4\u8F03",
          navActive: 5,
          onClick: function onClick() {
            return ga(["導航", "比較"]);
          },
          href: "".concat(c, "/photoModel-compare.html"),
          active: -1
        });
      },
      evPages: function evPages() {
        return /*#__PURE__*/React.createElement(NavText, {
          id: 'newTopNav9',
          title: "\u96FB\u52D5\u8ECA",
          navActive: 9,
          onClick: function onClick() {
            ga(["導航", "電動車"]);
            ga4Collect("element_clicked", {
              page_sub_business: "中古車首頁",
              page_business: "中古車",
              trigger_id: "2369",
              page_id: "484",
              trigger_name: "電動車",
              next_spm: "38.484.265.554",
              page: "首頁",
              channel: "中古車",
              element_id: "電動車",
              element: "按鈕",
              module: "頂部tab欄",
              tracker_method: "config"
            });
          },
          href: "".concat(c, "/ev"),
          active: -1
        });
      },
      helpSell: function helpSell() {
        return /*#__PURE__*/React.createElement(React.Fragment, null, !["autoSlim", "autoIndexSlim", "imIndexSlim"].includes(type) && (/*#__PURE__*/React.createElement(NavAgentCustomer, {
          title: "\u696D\u4EE3\u7372\u5BA2",
          onClick: function onClick() {
            return ga(["導航", "業代獲客"]);
          },
          href: "".concat(c, "/agent/investment?globalSource=tabbar"),
          // 要区分 type
          type: 'slim'
        })), /*#__PURE__*/React.createElement(NavHelpSell, {
          title: "\u8ECA\u5546\u8CE3\u8ECA",
          onClick: function onClick() {
            return ga(["導航", "快速賣車"]);
          },
          href: "".concat(www, "/help-sell.html"),
          // 要区分 type
          type: type
        }));
      },
      search: function search() {
        return /*#__PURE__*/React.createElement(NavSearch, {
          keyword: keyword,
          def: def.current || {},
          www: www,
          image: image,
          ga: ga,
          ga4: ga4Collect,
          // 要区分 type
          type: 'slim',
          fixed: false,
          handlePostInitialCollect: handlePostInitialCollect,
          fetchSearchSuggest: fetchSearchSuggest,
          postInitialCollect: postInitialCollect,
          fetchSearchRecommend: fetchSearchRecommend
        });
      },
      user: function user() {
        return /*#__PURE__*/React.createElement(NavUser, {
          userNav: userNav,
          www: www,
          c: c
        });
      },
      help: function help() {
        return /*#__PURE__*/React.createElement(NavHelp, {
          www: www,
          onlineService: onlineService,
          image: image
        });
      },
      app: function app() {
        return /*#__PURE__*/React.createElement(NavApp, {
          image: image
        });
      }
    }
  }, /*#__PURE__*/React.createElement("a", {
    className: 'tc-top-nav-logo-text',
    href: www
  }, "8891\u6C7D\u8ECA\u9996\u9801"))));
};
export default SlimNav;